import { ProfileCompletionBonusCampaignState, ProfileCompletionBonusSummaryResponse } from '../api/api.g';

export const hasProfileBonusOffer = (summary?: ProfileCompletionBonusSummaryResponse) =>
  summary?.campaignState === ProfileCompletionBonusCampaignState.Active && summary.eligible &&
  !summary.awardedAtUtc && !summary.pendingAward && summary.missingQuestionKeys.length > 0;

export const showProfileBonusProgress = (summary?: ProfileCompletionBonusSummaryResponse) =>
  !!hasProfileBonusOffer(summary);

export const profileBonusSections = [
  { key: 'profile-bonus-employment', questions: ['EmploymentStatus'] },
  { key: 'profile-bonus-income', questions: ['HouseholdIncome'] },
  { key: 'profile-bonus-household', questions: ['HouseholdSize'] },
  { key: 'profile-bonus-children', questions: ['HasChildrenUnder18', 'ChildrenAges'] },
];
